var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { PLCCEntryPointFullWidthDTW, PLCCEntryPointHalfWidthDTW, } from '../../../shared/rewards-hub/plcc-entry-point-card/plcc-entry-point-dtw';
import { PLCCEntryPointHalfWidthMW } from '../../../shared/rewards-hub/plcc-entry-point-card/plcc-entry-point-mw';
import { InfoPerksContext, InfoRewardsContext, PerkProgressContext, PerkProgressProvider, } from '../../../../contexts';
import { editLiveChatZIndex } from '../../../../utils/GeneralUtil';
import { PacPxccDrawer } from '../../Drawer/PacDrawers/PxccDrawer';
export var PLCCEntryPointDTW = function (props) {
    var _a = React.useState(false), PLCCtoggle = _a[0], setPLCCtoggle = _a[1];
    var perksInfo = props.perksInfo, fullWidth = props.fullWidth;
    var plccSwitch = React.useContext(PerkProgressContext).plccSwitch;
    React.useEffect(function () {
        var timeoutId = setTimeout(function () {
            editLiveChatZIndex();
        }, 100);
        return function () { return clearTimeout(timeoutId); };
    }, [PLCCtoggle]);
    var data = __assign(__assign({}, props), { plccSwitch: plccSwitch, perksInfo: perksInfo, setPLCCtoggle: setPLCCtoggle });
    return (React.createElement(React.Fragment, null,
        React.createElement(PacPxccDrawer, { setTogglePLCC: setPLCCtoggle, togglePlcc: PLCCtoggle, perksInfo: perksInfo, plccSwitch: plccSwitch, isMobile: true }),
        fullWidth ? (React.createElement(PLCCEntryPointFullWidthDTW, __assign({}, data))) : (React.createElement(PLCCEntryPointHalfWidthDTW, __assign({}, data)))));
};
export var PLCCEntryPointMW = function (props) {
    var _a = React.useState(false), PLCCtoggle = _a[0], setPLCCtoggle = _a[1];
    var perksInfo = props.perksInfo;
    var plccSwitch = React.useContext(PerkProgressContext).plccSwitch;
    React.useEffect(function () {
        var timeoutId = setTimeout(function () {
            editLiveChatZIndex();
        }, 100);
        return function () { return clearTimeout(timeoutId); };
    }, [PLCCtoggle]);
    var data = __assign(__assign({}, props), { plccSwitch: plccSwitch, perksInfo: perksInfo, setPLCCtoggle: setPLCCtoggle });
    return (React.createElement(React.Fragment, null,
        React.createElement(PacPxccDrawer, { setTogglePLCC: setPLCCtoggle, togglePlcc: PLCCtoggle, perksInfo: perksInfo, plccSwitch: plccSwitch, isMobile: true }),
        React.createElement(PLCCEntryPointHalfWidthMW, __assign({}, data))));
};
export var PLCCEntryPoint = function (_a) {
    var isMobile = _a.isMobile, fullWidth = _a.fullWidth;
    var tempPerksInfo = React.useContext(InfoPerksContext).perksInfo;
    var _b = React.useContext(InfoRewardsContext), rewardsInfo = _b.rewardsInfo, isBlendedRewardsEnabled = _b.isBlendedRewardsEnabled;
    var perksInfo = isBlendedRewardsEnabled ? rewardsInfo : tempPerksInfo;
    var data = {
        isMobile: isMobile,
        perksInfo: perksInfo,
        fullWidth: fullWidth,
    };
    if (isMobile)
        return (React.createElement(PerkProgressProvider, { perksInfo: perksInfo },
            React.createElement(PLCCEntryPointMW, __assign({}, data))));
    return (React.createElement(PerkProgressProvider, { perksInfo: perksInfo },
        React.createElement(PLCCEntryPointDTW, __assign({}, data))));
};
